<div class="jamba-dialog">
  <button
    class="close-btn"
    mat-icon-button
    (click)="close()"
    aria-label="Close AI21 Jamba 1.5 Large Info"
  >
    ×
  </button>

  <div class="header">
    <img src="assets/logos/ai21.png" alt="AI21 Jamba 1.5 Large Logo" class="mini-logo" />
    <h2>AI21&nbsp;Jamba&nbsp;1.5 Large</h2>
    <div class="sub">Production-ready MoE model built for long context, high throughput, and enterprise-grade workflows</div>
  </div>

  <div class="body">
    <p>
      <strong>Jamba&nbsp;1.5 Large</strong> is designed for real production use—especially when you need both
      <strong>extreme context length</strong> and <strong>efficient serving</strong>. Its
      <strong>Mixture-of-Experts (MoE)</strong> approach helps scale performance while keeping throughput high, making it a strong
      fit for <strong>RAG</strong>, <strong>document-heavy systems</strong>, and <strong>knowledge assistants</strong> that must stay responsive.
    </p>

    <ul>
      <li>🧠 <strong>Mixture-of-Experts efficiency:</strong> routes each request to specialized “experts,” helping balance quality and speed at scale.</li>
      <li>📚 <strong>Very long context:</strong> built for large documents, multi-file codebases, and knowledge repositories where keeping more in-window matters.</li>
      <li>🔎 <strong>Great for RAG + search:</strong> strong in grounded Q&amp;A, summarization, extraction, and synthesis over retrieved sources.</li>
      <li>🌍 <strong>Multilingual:</strong> supports global applications and mixed-language enterprise content.</li>
      <li>💸 <strong>Cost-aware serving:</strong> designed for production throughput—useful when latency and unit economics matter.</li>
    </ul>

    <div class="optimal">
      <h3>Best use cases</h3>
      <ul>
        <li><strong>Enterprise search:</strong> deep Q&amp;A over large corpora with retrieval + summaries</li>
        <li><strong>Knowledge management:</strong> policies, research, legal docs, onboarding libraries, and SOPs</li>
        <li><strong>Long-form technical work:</strong> specs, documentation, and multi-file code assistance</li>
        <li><strong>Memory-intensive chat:</strong> assistants that need to track long histories or large reference packs</li>
        <li><strong>Global deployments:</strong> multilingual support and international customer experiences</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>How to get the best results</h3>
      <ul>
        <li><strong>Use retrieval intentionally:</strong> chunk documents well and pass only the most relevant passages.</li>
        <li><strong>Ask for structure:</strong> request headings, bullet summaries, tables, or JSON to keep outputs consistent.</li>
        <li><strong>Set constraints:</strong> define tone, length, must-include fields, and forbidden content.</li>
        <li><strong>Validate at scale:</strong> keep a golden set of prompts and run regression tests as your data changes.</li>
      </ul>
    </div>

    <div class="optimal">
      <h3>Pro tip</h3>
      <ul>
        <li>
          Jamba 1.5 Large is strongest when your system needs <strong>long-context comprehension</strong> plus
          <strong>high throughput</strong>—especially for enterprise RAG, large-document summarization, and robust knowledge assistants.
        </li>
      </ul>
    </div>
  </div>
</div>
